import * as Sentry from '@sentry/react'
import _ from 'lodash'

import { RESPONSE, Request } from 'constants/http'

const tryParseBody = (body) => {
  try {
    if ('string' === typeof body) return JSON.parse(JSON.stringify(body))

    if (body instanceof FormData) {
      return _.fromPairs(Array.from(body.entries()))
    }

    return body
  } catch {
    return body
  }
}

const SentryMiddleware = async (request: Request, next) => {
  const response = await next(request)

  try {
    if (response.clone) {
      const clone = response.clone()
      const data = await clone.json()

      if (
        RESPONSE.HTTP_500_INTERNAL_SERVER_ERROR === response.status
        || data?.error?.code === RESPONSE.HTTP_500_INTERNAL_SERVER_ERROR
      ) {
        const requestDetails = {
          body: request.body ? tryParseBody(request.body) : undefined,
          headers: request.headers,
          method: request.method,
          query: request.uri?.includes('?')
            ? Object.fromEntries(new URLSearchParams(request.uri.split('?')[1]))
            : {},
          url: request.uri,
        }

        const errorMessage = data?.error?.message || ''

        const skipPatterns = [
          /^Subdomain ".+" does not point to any organization or nursery$/,
          /^Scope from the token does not match request scope\.$/,
          /^Item not found for "\/v2\/child_observations\/\d+"$/,
        ]

        if (!skipPatterns.some((pattern) => pattern.test(errorMessage))) {
          Sentry.captureException(new Error(`[${data.error.code}] ${errorMessage}`), {
            extra: {
              request: JSON.parse(JSON.stringify(requestDetails)),
              response: JSON.parse(JSON.stringify(data)),
            },
            fingerprint: [`${data.error.code}`, errorMessage],
            level: 'fatal',
          })
        }
      }
    }
  } catch {}

  return response
}

export default SentryMiddleware
